module.exports = __webpack_public_path__ + "images/hero-ca@2.2d2e36f56bb90e2754281a64be9491e9.jpg";